<template>
    <div class="modal fade custom-modal" id="publicAppointmentProject" data-hashtag="programeaza-o-vizionare" tabindex="-1" role="dialog"
         aria-labelledby="newProjectModalTitle" aria-hidden="true" data-keyboard="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content custom-modal-content new-project-modal-content">

                <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
                    <i class="fad fa-times-circle"></i>
                </div>

                <div class="modal-header custom-modal-header">
                    <div class="modal-title">
                        Programeaza o vizionare
                    </div>
                </div>

                <form id="publicAppointmentProjectForm">
                    <input type="hidden" name="project_id" :value="this.project ? this.project.id : null">
                    <input type="hidden" name="model_id" :value="this.model ? this.model.id : null">
                    <div class="modal-body custom-modal-body" id="publicAppointmentProjectModalBody">
                        <div class="input-container">
                            <div class="input-group mg-b">
                                <input type="text" id="name_appointment" @keypress="isLetter($event)" name="sender_name" v-model="userNameInput"
                                       placeholder="Nume">
                                <div class="input-icon">
                                    <i class="fas fa-signature"></i>
                                </div>
                                <label class="custom-label" for="name_appointment">Nume</label>
                            </div>
                            <p class="custom-input-error" id="sender_name_error"></p>
                        </div>
                        <div class="input-container">
                            <div class="input-group mg-b">
                                <input type="email" id="email_appointment" name="sender_email" v-model="userEmailInput"
                                       placeholder="Email">
                                <div class="input-icon">
                                    <i class="fad fa-at"></i>
                                </div>
                                <label class="custom-label" for="email_appointment"> Email </label>
                            </div>
                            <p class="custom-input-error" id="sender_email_error"></p>
                        </div>
                        <div class="input-container">
                            <div class="input-group mg-b">
                                <input type="text" @input="validatePhoneNumber" id="phone_appointment" name="sender_phone" v-model="userPhoneInput"
                                       placeholder="Telefon">
                                <div class="input-icon">
                                    <i class="fad fa-phone-rotary"></i>
                                </div>
                                <label class="custom-label" for="phone_appointment"> Telefon </label>
                            </div>
                            <p class="custom-input-error" id="sender_phone_error"></p>
                        </div>
                        <div class="modal-appointment__input-title">
                            Selectati ziua
                        </div>
                        <div class="modal-appointment__date-container">
                            <div class="modal-appointment__dates" id="dates-container">
                                <div class="modal-appointment__date" v-for="(day, i) in daysList" :key="i">
                                    <input
                                        :id="'date'+i"
                                        type="radio"
                                        name="date_input"
                                        :value="day.date"
                                        class="modal-appointment__date-input"
                                        v-model="dayInput">
                                    <label :for="'date'+i" class="modal-appointment__date-label">
                                        <div class="modal-appointment__date-text">{{day.date}}</div>
                                        <div class="modal-appointment__date-break"></div>
                                        <div class="modal-appointment__date-text modal-appointment__date-text--small">{{day.name}}</div>
                                    </label>
                                </div>
                            </div>
                            <div class="modal-appointment__date-arrow" @click="arrowScroll(-1)">
                                <i class="fas fa-chevron-left"></i>
                            </div>
                            <div class="modal-appointment__date-arrow modal-appointment__date-arrow--right" @click="arrowScroll(1)">
                                <i class="fas fa-chevron-right"></i>
                            </div>
                            <p class="custom-input-error" id="date_input_error"></p>
                        </div>
                        <div class="modal-appointment__input-title">
                            Selectati ora
                        </div>
                        <div class="modal-appointment__hours-display" @click="handleHoursDisplayClick">
                            <span v-if="!hourInput">Selectati ora</span>
                            <span v-else>{{hourInput}}</span>
                            <i class="fas fa-chevron-down" v-if="!showHoursList"></i>
                            <i class="fas fa-chevron-up" v-else></i>
                            <div class="modal-appointment__hours-icon">
                                <i class="fad fa-clock"></i>
                            </div>
                        </div>
                        <p class="custom-input-error" id="hour_input_error"></p>
                        <div class="modal-appointment__hours-list" v-show="showHoursList">
                            <div class="modal-appointment__hour-item" v-for="(hour, i) in hoursList" :key="i">
                                <input 
                                    type="radio" 
                                    name="hour_input"
                                    :id="'hour'+i"
                                    :value="hour.interval"
                                    v-model="hourInput">
                                <label :for="'hour'+i">
                                    {{hour.interval}}
                               </label>
                            </div>
                        </div>
                        <div class="general-check">
                            <input type="checkbox" name="terms" id="terms_new_appointment" class="custom-checkbox"
                                   value="1" v-model="termsCheck">
                            <label for="terms_new_appointment" class="custom-checkbox-label">
                                <span></span>
                                <p>
                                    * Sunt de acord cu <a href="/page/termeni-si-conditii" target="_blank"
                                                          class="p-color"> Termenii si Conditiile </a>
                                    siteului.
                                </p>
                            </label>
                            <p class="custom-input-error" id="terms_error"></p>
                            <!-- Mesajul de eroare pt formular -->
                            <div class="check-error" style="display: none;">
                                <span class="check-error-message" role="alert">
                                    <p class="custom-input-error" id="terms_error_appointment" style="text-align: left;">
                                        Completati toate campurile pentru a putea trimite cererea
                                    </p>
                                </span>
                            </div>
                        </div>
<!--                        <div class="recaptcha-box">-->
<!--                            <div id="appointment-recaptcha"></div>-->
<!--                            <div class="check-error">-->
<!--                                <span class="check-error-message" role="alert">-->
<!--                                    <p class="custom-input-error" id="g-recaptcha-response_error"> </p>-->
<!--                                </span>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                    <div class="modal-footer custom-modal-footer">
                        <button type="button" class="general-btn positive-btn modal-appointment__button" @click="sendAppointmentRequest">
                            <span> Trimite cererea </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
function sideScroll(element, direction, speed, distance, step) {
    let scrollAmount = 0;
    var slideTimer = setInterval(function () {
        element.scrollLeft += direction * step;
        scrollAmount += step;
        if (scrollAmount >= distance) {
            window.clearInterval(slideTimer);
        }
    }, speed);
}

  export default {
    name: "publicAppointmentProject",
    props: ['userName', 'userPhone', 'userEmail'],
    data() {
      return {
        project: null,
        model: null,
        message: '',
        isLoggedIn: !!this.$userId,
        userNameInput: this.userName,
        userPhoneInput: this.userPhone,
        userEmailInput: this.userEmail,
        dayInput: null,
        hourInput: null,
        showHoursList: false,
        termsCheck: false,
        daysList: [],
        appointmentRecaptchaId: null,
        hoursList: [
            {
                interval: '9:00-9:30'
            },
            {
                interval: '9:30-10:00'
            },
            {
                interval: '10:00-10:30'
            },
            {
                interval: '10:30-11:00'
            },
            {
                interval: '11:00-11:30'
            },
            {
                interval: '11:30-12:00'
            },
            {
                interval: '12:00-12:30'
            },
            {
                interval: '12:30-13:00'
            },
            {
                interval: '13:00-13:30'
            },
            {
                interval: '13:30-14:00'
            },
            {
                interval: '14:00-14:30'
            },
            {
                interval: '14:30-15:00'
            },
            {
                interval: '15:00-15:30'
            },
            {
                interval: '15:30-16:00'
            },
            {
                interval: '16:00-16:30'
            },
            {
                interval: '16:30-17:00'
            },
            {
                interval: '17:00-17:30'
            },
            {
                interval: '17:30-18:00'
            },
        ]
      }
    },
    mounted() {
    //   this.resetModalData();
      let vm = this
        for(let i=0;i<10;i++) {
            let date = window.moment().add(i, 'days');
            this.daysList.push({
                date: date.format('D MMM'),
                name: date.format('dddd')
            });
        }
      $('#publicAppointmentProject').on('hidden.bs.modal', function () {
        vm.project = null
        // window.grecaptcha.reset(vm.appointmentRecaptchaId);
      });
      this.$eventBus.$on('OPEN_APPOINTMENT_MODAL_PROJECT', function (payLoad) {
        // vm.initAppointmentRecaptcha();
        vm.project = payLoad.project;
        vm.model = payLoad.model || null;
        $('#publicAppointmentProject').modal('show')
      });
    },
    methods: {
        sendAppointmentRequest() {
            let vm = this
            this.triggerLoader(true)
            window.resetErrors()
            let myForm = document.getElementById('publicAppointmentProjectForm');
            let formData = new FormData(myForm);
            window.axios.post('/ajax/request-appointment', formData)
                .then(function () {
                    window.Swal.fire({
                        html: 'Cererea ta a fost trimisa cu succes',
                        icon: 'success',
                        timer: 2000,
                        showCancelButton: false,
                        showConfirmButton: false
                    }).then(() => {
                        $('#publicAppointmentProject').modal('hide')
                        $('#publicAppointmentProjectForm')[0].reset();
                        $('#contact_terms').prop("checked", false);
                        // window.grecaptcha.reset(vm.appointmentRecaptchaId);
                        vm.resetModalData();
                    })
                    vm.triggerLoader(false)
                })
                .catch(function (err) {
                    // window.grecaptcha.reset(vm.appointmentRecaptchaId);
                    window.showError(err, 'publicAppointmentProjectForm')
                    vm.triggerLoader(false)
                });
        },
        arrowScroll(direction) {
            var datesContainer = document.getElementById("dates-container");
            var animWidth = datesContainer.offsetWidth - 80;
            sideScroll(datesContainer, direction, 10, animWidth, 20);
        },
        resetModalData() {
            this.project = null;
            this.model = null;
            this.message = '';
            this.userNameInput = '';
            this.userEmailInput = '';
            this.userPhoneInput = '';
            this.dayInput = null;
            this.hourInput = null;
            this.showHoursList = false;
            this.termsCheck = false;
        },
        validatePhoneNumber() {
            this.userPhoneInput = this.userPhoneInput.replace(/[^0-9]/g, '');
        },
        initAppointmentRecaptcha() {
            let vm = this;
            setTimeout(() => {
                if (typeof window.grecaptcha === 'undefined' || typeof window.grecaptcha.render ==='undefined')
                    vm.initAppointmentRecaptcha();
                else
                {
                    if(!vm.appointmentRecaptchaId)
                    {
                        try {
                            vm.appointmentRecaptchaId = window.grecaptcha.render('appointment-recaptcha', {
                                'sitekey' : process.env.MIX_RECAPTCHA_SITE_KEY,
                                'theme' : 'light',
                                'size' : 'normal'
                            });
                        } catch(err)
                        {
                            console.log(err);
                        }
                    }
                }
            }, 200);
        },
        isLetter(e) {
            let char = String.fromCharCode(e.keyCode);
            if(/^[A-Za-z]+$/.test(char)) return true; 
            else e.preventDefault();
        },
        handleHoursDisplayClick() {
            let vm = this;
            vm.showHoursList = !vm.showHoursList;

            if(vm.showHoursList) {
                setTimeout(function(){
                    let modelBody = document.getElementById("publicAppointmentProjectModalBody");
                    $(modelBody).animate({scrollTop:modelBody.scrollHeight}, '300');
                }, 100);
            }
        }
    },
    watch: {
        hourInput() {
            this.showHoursList = false;
        }
    }
  }
</script>

<style scoped>

</style>
